import { render, staticRenderFns } from "./TokenPage.vue?vue&type=template&id=51abac8b&scoped=true"
import script from "./TokenPage.vue?vue&type=script&lang=js"
export * from "./TokenPage.vue?vue&type=script&lang=js"
import style0 from "./TokenPage.vue?vue&type=style&index=0&id=51abac8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51abac8b",
  null
  
)

export default component.exports